import { Divider, Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import type { FC } from 'react';

import { useInfiniteScroll } from '../../hooks/infinite-scroll.hooks';
import type { AssetType, Listing } from '../../lib/graph/MogulMarketplace';
import { ListingType } from '../../lib/graph/MogulMarketplace';
import otherListingsQuery from '../../lib/graph/queries/otherListingsQuery';
import { NftListingRowComponent } from './nft-listing-row/NftListingRow.component';
import styles from './NftListing.module.css';

interface NftHistoryProps {
  nftContractAddress: string;
  nftId: string;
  walletAddress: string;
  type: AssetType;
  isWhitelisted: boolean;
  isWhitelistAddress: boolean;
}

export const NftListingComponent: FC<NftHistoryProps> = ({
  nftContractAddress,
  nftId,
  walletAddress,
  isWhitelisted,
  isWhitelistAddress,
}) => {
  const { loading, fetchedData, loader } = useInfiniteScroll<{
    listings: Listing[];
  }>(
    otherListingsQuery,
    {
      listings: [],
    },
    curr => prev => ({
      listings: [...prev.listings, ...curr.listings],
    }),
    d => !d.listings.length,
    {
      variables: {
        graphId: `${nftContractAddress}/${nftId}`,
        seller: walletAddress,
        first: 20,
      },
      pollInterval: 5000,
    },
  );

  const currentTime = Math.floor(Date.now() / 1000);

  const filteredListings = fetchedData.listings.filter(
    listing =>
      listing.type === ListingType.Listing || currentTime < listing.endTime,
  );

  return (
    <div className={styles.nftListingContainer}>
      <Typography
        variant="h1"
        style={{
          fontSize: 32,
          marginBottom: 10,
        }}
      >
        Listings ({filteredListings.length})
      </Typography>
      <div className={`rounded-lg ${styles.listingBackground}`}>
        {loading
          ? Array.from(Array(5).keys()).map(i => (
              <Skeleton height={75} key={i} />
            ))
          : filteredListings.map((listing, i) => (
              <div key={i}>
                {i !== 0 && <Divider />}
                <NftListingRowComponent
                  {...listing}
                  isWhitelisted={isWhitelisted}
                  isWhitelistAddress={isWhitelistAddress}
                />
              </div>
            ))}
        <div className="h-px" ref={loader}></div>
      </div>
    </div>
  );
};
